export enum TabSelectorForContentPromotionVenue {
  district = "promoted-at-your-district",
  school = "promoted-at-your-school",
}
